import classNames from 'classnames';
import omit from "omit.js";
import React, { useMemo } from 'react';
import { WebUI, getNid } from "../../wui-core/src/index";
import { SvgIconProps } from './iSvgIcon';

// const propTypes = {
//     className: PropTypes.string,
//     type: PropTypes.string,
//     component: PropTypes.func,
//     viewBox: PropTypes.string,
//     fieldid: PropTypes.string,
// };
const defaultProps = {
    viewBox: "0 0 1024 1024",
    clsPrefix: 'u-svgicon',
};

const SvgIconComponent: React.FC<SvgIconProps> = (props) => {
    const {
        className,
        type,
        component,
        viewBox,
        clsPrefix,
        children,
        fieldid,
        fontFamily,
    } = props;

    const Component = component;
    const adapterNid = getNid(props);

    const classString = useMemo(() => classNames({
        [`${clsPrefix}`]: true,
    }), [clsPrefix]);

    const renderInnerNode = () => {
        // component > type
        if (Component) {
            return (
                <i {...omit(props, ["clsPrefix", "component"])} {...adapterNid}>
                    <Component>{children}</Component>
                </i>
            );
        }

        return (
            <svg
                className={classNames(className, classString)}
                fieldid={fieldid}
                aria-hidden="true"
                viewBox={viewBox}
                {...adapterNid}
            >
                <use xlinkHref={fontFamily ? `#${fontFamily}` : `#uftype-${type}`}></use>
            </svg>
        );
    };

    return renderInnerNode();
};

const SvgIcon = WebUI({ name: "svgicon", defaultProps })(SvgIconComponent);

// SvgIcon.propTypes = propTypes;
export default SvgIcon;
